import personalWebsitePreview from '../images/personalWebsitePreview.png';
import hiraganaFlashcardsPreveiw from '../images/hiraganaFlashcardsPreview.png';
import studyAbroadPreview from '../images/studyAbroadPreveiw.png';

const portfolio = [
    {
        id: '01',
        title: 'Hiragana Flashcards - Practice Hiragana!',
        desc: 'Hiragana Flashcards is a small application that helps beginners study Hiragana. Knowing Hiragana lays the foundation of your first month of studying Japanese!',
        imgUrl: hiraganaFlashcardsPreveiw,
        stack: ['HTML', 'CSS', 'JavaScript', 'ReactJS', 'MongoDB', 'JSON'],
        link: 'https://practice-hiragana.netlify.app/',
        repo: 'https://github.com/ericanwoga/hiragana-flashcards',
    },
    {
        id:'02',
        title: 'My Portfolio Website',
        desc: 'I built my own portfolio website from scratch using Javascript and ReactJS. I first drew wireframes to get an idea for the layout, then brought it to life!',
        imgUrl: personalWebsitePreview,
        stack: ['HTML', 'CSS', 'JavaScript', 'ReactJS'],
        link: 'https://ericanwoga.netlify.app/',
        repo: 'https://github.com/ericanwoga/ericanwoga.dev',
    },
    {
        id:'03',
        title: 'Study Abroad Website',
        desc: 'I built a fun little brochure website to learn more about Node.js, databases, and REST APIs.The website collects the user\'s data, then displays relevant historical information of the user\'s desired city.',
        imgUrl: studyAbroadPreview,
        stack: ['Node.js', 'Express.js','JavaScript', 'CSS', 'MondgoDB', 'MediaWiki API'],
        link: 'https://study-abroad.onrender.com',
        repo: 'https://github.com/ericanwoga/study-abroad',
    },

];

export default portfolio;
